<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="openNote" class="comment-dialog" :modal="false">
      <div slot="title" class="dialog-header">
          <img class="collect-icon" src="@/assets/images/bookIcons/note3.png" alt="">
          <div class="collect-title">笔记</div>
          <div class="line-area"></div>
      </div>
      <div>
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
              class="all-checked">全选</el-checkbox>
          <div class="totalNum">
              <div class="allDelete">
                  <i class="el-icon-delete" @click='deleteNote' title="删除笔记"></i>
              </div>
              数目：<div class="total">{{ total }}</div>
          </div>
      </div>
      <el-checkbox-group v-model="checkedNotes" @change="handleCheckedNotesChange" class="checkbox">
          <div class="checkbox-box" v-for="(note, index) in notes" :key="index">
              <el-checkbox :label="note.id" @change="checkClick(note)">{{ bookName }}</el-checkbox>
              <!-- <el-checkbox :label="note.id" @change="checkClick(note)">{{ note.bookId }}</el-checkbox> -->
              <div class="checkbox-note">
                  <span class="editnote" style="white-space: pre-wrap;">{{ note.note }}</span>
                  <!-- <span v-if="editIndex !== index"> {{ note.note }} </span>
                  <span v-else>
                      <el-input class="input" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                          v-model="inputPoint" :placeholder="note.note"></el-input>
                  </span> -->
              </div>
              <div class="checkbox-time">
                  <div>{{ note.time }}</div>
                  <img src="@/assets/images/bookIcons/response.png" class="response" @click="editNote(index)" title="编辑笔记">
              </div>
              <div v-show="editIndex===index">
                  <div class="input">
                      <el-input ref="edit" :autofocus="true" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                          placeholder="请输入笔记" v-model="textarea1">
                      </el-input>
                  </div>
                  <div class="button-box">
                      <button class="confirm" @click="saveNote(note.noteId)">保存</button>
                      <button class="confirm" @click="editIndex=-1" style="margin-left:10px;margin-right:10px;">取消</button>
                  </div>
              </div>
          </div>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
          <div class="input">
              <el-input ref="input" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入笔记"
                  v-model="textarea2">
              </el-input>
          </div>
          <div class="button-box">
              <button class="confirm" @click="addNote">添加笔记</button>
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui"
export default {
  name: 'RetrieveDialogNote',
  props: {
    openNote: {
      type: Boolean,
      required: true
    },
    bookId: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },

  watch: {
    openNote () {
      this.$emit('closeNote', false)
    }
  },
  data () {
    return {
      notes: [
        // {
        //   id: 0,
        //   bookId: this.bookId,
        //   note: '本书很不错，值得阅读',
        //   time: '2022-11-23 10:00',
        //   clicked: false
        // },
        // {
        //   id: 1,
        //   bookId: this.bookId,
        //   note: '本书很不错，值得阅读',
        //   time: '2022-11-23 10:00',
        //   clicked: false
        // }
      ],
      checkedNotes: [],
      deleNotes: [],
      checkAll: false,
      isIndeterminate: true,
      textarea1: '',
      textarea2: '',
      inputPoint: '',
      editIndex: -1,
      total: 0,
      bookName: '《医方论》'
    }
  },
  created () {
    let url = 'retrieve/book/getBookInfo?bookId=' + this.bookId
    this.$http.post(url).then(res => {
      this.bookName = res.data.data.bookName
    })
    this.getNote()
  },
  methods: {
    getNote () {
      this.notes = []
      this.checkAll = false
      this.checkedNotes = []
      this.deleNotes = []
      // 获取某人某本书某页的笔记
      let userId = localStorage.getItem('userId')
      let url = 'retrieve/notes/getBookNoteOnePage?userId=' + userId + '&bookId=' + this.bookId + '&page=' + this.currentPage
      this.$http.get(url).then(res => {
          // console.log(res.data.data)
          this.total = res.data.data.length
          for (let i in res.data.data) {
            let arr = res.data.data[i].notes.notes.split(/[\n]/)
            let tmpnote = ''
            for (let i =0 ; i < arr.length - 1 ; i++) {
              tmpnote = tmpnote + arr[i] + '\n    '
            }
            tmpnote = tmpnote + arr[arr.length - 1]
            let tmp = {
              id: i,
              bookId: this.bookId,
              noteId: res.data.data[i].notes.id,
              note: tmpnote,
              time: res.data.data[i].notes.updateTime,
              clicked: false
            }
            this.notes.push(tmp)
          }
          // console.log(this.total)
          // console.log(this.notes)
        })
        .catch(err => {
          alert(err.message)
          console.log(err)
        })
    },
    handleCheckAllChange (val) {
      const checked = this.notes.map(item => {
        this.deleNotes.push(item.id)
        return item.id
      })
      this.checkedNotes = val ? checked : []
      // console.log('checknotes', this.checkedNotes)
      this.isIndeterminate = false
    },
    handleCheckedNotesChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.notes.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.notes.length
    },
    checkClick (note) {
      note.clicked = !note.clicked
      if (note.clicked) {
        this.deleNotes.push(note)
      } else {
        this.deleNotes = this.deleNotes.filter(item => item.bookId !== this.bookId)
      }
    },
    deleteNote () {
      let userId = localStorage.getItem('userId')
      // 全选删除
      if(this.checkAll) {
        let url='retrieve/notes/deleteBookNoteByPage?userId=' + userId + '&bookId=' + this.bookId + '&page=' + this.currentPage
        this.$http.post(url).then(
          res => {
            Message({
              type: 'success',
              message: '笔记删除成功!',
            })
            this.getNote()
            this.checkAll = false
          },
          err => {
            console.log('删除失败')
          }
        )
      } else {// 部分删除
        for(let i in this.deleNotes) {
          let url = 'retrieve/notes/deleteOneNotesById?noteId=' + this.deleNotes[i].noteId
          this.$http.post(url).then(
            res => {
              Message({
                type: 'success',
                message: '笔记删除成功!',
              })
              this.getNote()
            },
            err => {
              console.log('删除失败')
            })
        }
      }
    },
    editNote (index) {
      this.editIndex = index
      let arr = this.notes[index].note.split(/[\n]/)
      let tmpnote = ''
      for (let i =0 ; i < arr.length - 1 ; i++) {
        arr[i] = arr[i].trimLeft()
        tmpnote = tmpnote + arr[i] + '\n'
      }
      tmpnote = tmpnote + arr[arr.length - 1].trimLeft()
      this.textarea1 = tmpnote
      this.$nextTick(() => {
        this.$refs.edit[index].focus()
      })
    },
    // 更新笔记
    saveNote (noteId) {
      this.editIndex = -1
      if (this.textarea1.length > 0 && this.textarea1.split(" ").join("").length > 0) {
        // console.log(this.textarea1)
        let note = {
          "noteId": noteId,
          "notes": this.textarea1
        }
        let params = new URLSearchParams()
        params.append('note', JSON.stringify(note))
        let url = 'retrieve/notes/updateBookNote'
        this.$http.post(url,params).then(res => {
          this.textarea1 = ''
          this.getNote()
        }, err => {
          alert(err.message)
        })
      } else {
        Message({
          type: 'error',
          message: '笔记不能为空!',
        })
      }
    },
    // 添加笔记
    addNote () {
      if (this.textarea2.length > 0 && this.textarea2.split(" ").join("").length > 0) {
        let userId = localStorage.getItem('userId')
        let note = {
          "userId": userId,
          "bookId": this.bookId,
          "page": this.currentPage,
          "notes": this.textarea2
        }
        let url = 'retrieve/notes/addNote'
        console.log(url)
        let params = new URLSearchParams()
        params.append('note', JSON.stringify(note))
        this.$http.post(url, params).then(
          res => {
            this.textarea2 = ''
            this.getNote()
          },
          err => {
            alert(err.message)
            console.log(err)
          })
      } else {
        Message({
          type: 'error',
          message: '笔记不能为空!',
        })
      }
    }
  }
}
</script>

<style scoped>
.comment-dialog>>>.el-dialog {
    width: 260px !important;
    height: 571px !important;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #F7F6F5;
    margin-right: 160px;
    text-align: left;
}
.comment-dialog ::-webkit-scrollbar {
  background-color: #f5eee8;
  width: 4px;
}
.comment-dialog >>> .el-dialog__headerbtn {
    top: 5px !important;
    right: 4px;
    background: url('../assets/images/bookIcons/close.png') left no-repeat;
    background-size: cover;
    font-family:"Avenir", Helvetica, Arial, sans-serif;
    width:20px;
    height: 20px;
}
.comment-dialog ::-webkit-scrollbar-thumb {
  background-color: #9e5c1d;
}
.collect-icon {
    width: 16.19px;
    height: 15.79px;
}

.comment-dialog>>>.el-dialog__header {
    padding: 15px 0 0 16px;
}

.comment-dialog>>>.el-dialog__body {
    padding: 22px 11px 0 10px;
}

.collect-title {
    font-size: 18px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    color: #9E5C1D;
    display: inline;
    margin: 0 0 13px 10px;
    bottom: 13px;
}

.line-area {
    width: 115px;
    margin-top: 12px;
    border-bottom: 1px solid #9E5C1D;
}

.all-checked {
    margin-left: 8px;
}

.totalNum {
    display: inline;
    float: right;
    color: #634C37;
    font-size: 14px;
}

.total {
    display: inline;
    float: right;
    color: #9E5C1D;
}

.allDelete {
    margin-left: 10px;
    display: inline;
    float: right;
}

.all-checked>>>.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #9E5C1D;
}

.all-checked>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #9E5C1D;
    border-color: #9E5C1D;
}

.all-checked>>>.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #9E5C1D;
}

.all-checked>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #9E5C1D;
    border-color: #9E5C1D;
}
.checkbox{
    height: 350px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.checkbox>>>.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #9E5C1D;
}

.checkbox>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #9E5C1D;
    border-color: #9E5C1D;
}

.checkbox>>>.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #9E5C1D;
}

.checkbox-box {
    width: 239px;
    /* height: 95px; */
    background: rgba(244, 242, 241, 0.26);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #F4F2F1;
    margin-top: 8px;
}

.checkbox-box>>>.el-checkbox__inner {
    margin-left: 10px;
}

.checkbox-box>>>.el-checkbox__label {
    margin-top: 7px;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #9E5C1D;
    line-height: 0px;
}

.checkbox-note {
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #634C37;
    line-height: 36px;
    margin-left: 8px;
    margin-right: 8px;
    text-indent: 20px; 
}

.checkbox-time {
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #AAA199;
    margin: 17px 10px 5px 10px;
    display: flex;
    justify-content: space-between;
}

.response {
    display: inline;
    width: 14px;
    height: 14px;
    margin-left: 12px;
    margin-top: 3px;
    /* float:right; */
    cursor: pointer;
}

.input {
    margin-top: 19px;
}

.input>>>.el-textarea__inner {
    background: rgba(99, 76, 55, 0.06);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid rgba(99, 76, 55, 0.09);
}

.confirm {
    width: 100px;
    height: 34px;
    background: #9E5C1D;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 0;
    padding: 0;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 6px;

}

.comment-dialog>>>.el-dialog__footer {
    position: absolute;
    bottom: 9px;
    padding: 0 5px 0 6px;
    width: 100%;
}

.comment-delete {
    display: inline;
    margin-left: 55px;
    /* margin-right: 17px; */
    cursor: pointer;
}
.button-box{
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveDialogNote.vue